// utils/draw/drawRectFromCode.js
import * as THREE from 'three';
import { generateUniqueId } from '../utils/generateUniqueId';

export function drawRectFromCode( target,{
  start,
  end,
  color = 0xffffff,
  layerName = '0',
  opacity = 1.0,
}) {
  if (  !start || !end) {
    console.warn('drawRectFromCode: start ve end noktaları gereklidir.');
    return;
  }

  const geometry = new THREE.BufferGeometry();

  const points = [
    new THREE.Vector3(start.x, start.y, 0),
    new THREE.Vector3(end.x, start.y, 0),
    new THREE.Vector3(end.x, end.y, 0),
    new THREE.Vector3(start.x, end.y, 0),
    new THREE.Vector3(start.x, start.y, 0), // başa dön
  ];

  const vertices = [];
  points.forEach((p) => vertices.push(p.x, p.y, p.z));

  geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));

  // ✅ Transparency desteği
  const materialOptions = { color };
  if (opacity < 1) {
    materialOptions.transparent = true;
    materialOptions.opacity = 1 - opacity;
  }
  const material = new THREE.LineBasicMaterial(materialOptions);
  const rect = new THREE.Line(geometry, material);

  rect.userData = {
    id: generateUniqueId('rect'),
    type: 'rect',
    isSelectable: true,
    originalColor: color,
    start,
    end,
    layerName,
  };

 // scene.add(rect);
 if (target) target.add(rect);
  return rect;
}

/*  KULLANIM 
drawRectFromCode(scene, {
  start: { x: -50, y: -30 },
  end: { x: 50, y: 30 },
  color: 0xffa500,
});
 */